import { arrayComparer, useMessageToState } from "./useMessageToState";

const getSpreads = (editor: eXpress.core.IEditor) =>
	editor.definition ? [...editor.definition.spreads] : []; // use fixed empty array to avoid rerendering?

/** Return a list of spreads, rerun when spreads are added/removed/moved */
export const useSpreads = () =>
	useMessageToState({
		name: "useSpreads",
		getState: getSpreads,
		filterMessage: eXpress.core.canPageBeAddedOrRemoved,
		comparer: arrayComparer,
	});
